// src/components/Seo.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

const Seo = ({
  title = "Soranova | Custom ERP & Software Solutions",
  description = "We provide custom ERP software for manufacturing, construction, and education sectors. Also experts in mobile app development and digital business solutions.",
  keywords = "ERP software, manufacturing ERP, education ERP, construction software, software development company, mobile app development, business automation, custom ERP development, web application development, IT solutions provider, enterprise software, digital transformation, CRM development",
  image = "https://soranova.in/logo.png",
  url = "https://soranova.in",
  organization = {
    name: "Soranova",
    logo: "https://soranova.in/logo.png",
    sameAs: [
      "https://facebook.com/soranova",
      "https://linkedin.com/company/soranova",
    ]
  }
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Schema.org Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: organization.name,
          url: url,
          logo: organization.logo,
          sameAs: organization.sameAs,
          description
        })}
      </script>
    </Helmet>
  );
};

export default Seo;
